/*
 * Mock data for the auth-free Socios previews (/dev/socios*), so the full
 * "Listado Socios" flow (list, detail panel, perfil, nuevo socio, eliminar,
 * QR de preinscripción) can be exercised without a backend/session. Passed to
 * <SociosPage demo={...} />. When a real /socios route is wired later it will
 * ignore this and pull live members instead.
 *
 * Shape (SOCIO): everything the page needs to render list + detail + profile.
 *   estado: 'activo' | 'caducado' | 'suspendido'
 *   saldo:  number (euros). <=0 → "Sin saldo" (red); <2 → amber; else green.
 *   expSoon: mark the Caducidad date red (próxima caducidad) in the list.
 */

const CONTACTO_DEFAULT = {
  phone: "+34 610 065 789",
  email: "email@ejemplo.com",
  address: "Rue del Percebe, 13",
  city: "Sevilla",
  cp: "41001",
};

const MEMBRESIA_DEFAULT = {
  dni: "23456789K",
  birthDate: "20/06/1980",
  alta: "11/06/2025",
  caducidad: "11/06/2026",
  tipoConsumo: "Lúdico",
  cuota: "Mensual",
  descuento: "Sin descuento",
  lineaCoste: "Defecto",
  consumoMax: 0,
  avalador: "18",
  duracion: "1 año",
  notas: "",
};

function socio(partial) {
  return { ...CONTACTO_DEFAULT, ...MEMBRESIA_DEFAULT, ...partial };
}

export const DEMO_SOCIOS = [
  socio({ id: "s25", number: 25, name: "Liam O'Reilly", email: "pepahuertas@yahoo.es", caducidad: "01/01/2029", saldo: 85.0, estado: "activo" }),
  socio({ id: "s26", number: 26, name: "Sofia Martinez", email: "sofiam@gmail.com", caducidad: "15/01/2029", saldo: 0, estado: "caducado" }),
  socio({ id: "s27", number: 27, name: "Xavier Nguyen", email: "xavier@yahoo.es", caducidad: "22/01/2029", saldo: 0.2, estado: "suspendido" }),
  socio({ id: "s28", number: 28, name: "Fatima El-Sharif", email: "fatimaelsharif@hotmail.com", caducidad: "05/02/2029", saldo: 95.1, estado: "activo" }),
  socio({ id: "s29", number: 29, name: "Elena Petrov", email: "pepahuertas@yahoo.es", caducidad: "10/02/2029", saldo: 82.4, estado: "activo" }),
  socio({ id: "s30", number: 30, name: "James Murphy", email: "pepahuertas@yahoo.es", caducidad: "20/02/2029", saldo: 0, estado: "suspendido" }),
  socio({ id: "s31", number: 31, name: "Chloe Zhang", email: "pepahuertas@yahoo.es", caducidad: "27/02/2029", saldo: 1.25, estado: "caducado" }),
  socio({ id: "s32", number: 32, name: "Omar Al-Mansour", email: "pepahuertas@yahoo.es", caducidad: "05/03/2029", saldo: 78.5, estado: "activo", expSoon: true }),
  socio({ id: "s33", number: 33, name: "Priya Sharma", email: "pepahuertas@yahoo.es", caducidad: "15/03/2029", saldo: 0, estado: "activo" }),
  socio({ id: "s34", number: 34, name: "Nicolas Dupont", email: "pepahuertas@yahoo.es", caducidad: "20/03/2029", saldo: 84.2, estado: "activo" }),
  socio({ id: "s35", number: 35, name: "Sara Alavi", email: "pepahuertas@yahoo.es", caducidad: "25/03/2029", saldo: 91.15, estado: "caducado", expSoon: true }),
  socio({ id: "s36", number: 36, name: "Marcus Johnson", email: "pepahuertas@yahoo.es", caducidad: "02/04/2029", saldo: 87.5, estado: "activo" }),
];

// A fully-fleshed member used by the detail panel / perfil / edit demos.
export const DEMO_FEATURED = socio({
  id: "featured",
  number: 18,
  name: "José María García de la Borbolla",
  firstName: "José María",
  lastName: "García de la Borbolla",
  email: "email@ejemplo.com",
  phone: "+34 610 065 789",
  address: "Rue del Percebe, 13",
  city: "Dos Hermanas",
  cp: "41001",
  dni: "23456789K",
  birthDate: "20/06/1980",
  alta: "11/06/2026",
  caducidad: "11/06/2027",
  saldo: 126.1,
  estado: "activo",
  tipoConsumo: "Lúdico",
  cuota: "Mensual",
  avalador: "18",
  notas: "Le gusta tela la periñaca.",
});

export const DEMO_TOTAL = 120;   // "47/120 socios" → 47 activos de 120 totales
export const DEMO_ACTIVOS = 47;
export const PREREGISTER_URL =
  "https://clubsagent.ai/pre-register/ybRa38y31Gn9szpT_jEkup55WjBS2zfRex2NYvtwvNw";

export const DEMO_DATA = {
  socios: DEMO_SOCIOS,
  featured: DEMO_FEATURED,
  total: DEMO_TOTAL,
  activos: DEMO_ACTIVOS,
  preRegisterUrl: PREREGISTER_URL,
};
